import React, { useEffect, useState } from "react";
import "./Orderlist.css";
import Intro from "../../images/orderlist_intro.svg";
import IntroMobile from "../../images/orderList-hero-img-mobile.svg";
import plane from "../../images/orderList-plane.svg";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DesktopNavbar from "../../components/Navbar/Desktop/DesktopNavbar";
import MobileNavbar from "../../components/Navbar/Mobile/MobileNavbar";
import AirplaneTicketIcon from "@mui/icons-material/AirplaneTicket";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faPlane } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import CryptoJS from "crypto-js";

function Orderlist() {
  const [orderList, setOrderList] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  const email = JSON.parse(localStorage.getItem("email"));


  useEffect(() => {
    
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));
    if (storedToken) {
      axios
        .get(`${baseAPI}customerget/GetCustomerOrderList?email=` + email, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          if (response) {
            setOrderList(response.data.data);
          } else {
            console.error(
              "Invalid token or expired session:",
              response.data.message
            );
            // Handle invalid token scenario
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
          if (error.response) {
            console.error("Response Data:", error.response.data);
            console.error("Response Status:", error.response.status);
            console.error("Response Headers:", error.response.headers);
          }
        });
    } else {
      console.error("No token found, redirect to login or show error");
    }
  }, []);

  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(
      Relocation_ID.toString(),
      key
    ).toString();
    return encodeURIComponent(ciphertext);
  }

  function nextPage(Relocation_ID) {
    const key = "dbbworldwidepvtltd";
    const encryptedRelocationID = encryptRelocationID(Relocation_ID, key);

    const url = `/orderSummary?ID=${encryptedRelocationID}`;
    window.open(url, "_blank");
  }

  return (
    <>
      <div
        style={{ padding: "0px", margin: "0px", backgroundColor: "#F6F3FF" }}
        className="main orderlist-mobile-view-hide"
      >
        <div
          style={{ padding: "0px", margin: "0px" }}
          className="container-fluid navbar-mobile-hide"
        >
          <DesktopNavbar />
        </div>
        <div className="container-fluid py-2 px-4">
          <div
            className="container-fluid orderlist-hero"
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              boxShadow:
                "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
            }}
          >
            <div
              className=""
              style={{ backgroundColor: "#F6F3FF", padding: "10px" }}
            >
              <img className="img-fluid container" src={Intro} />
            </div>
          </div>
        </div>
        <div className="container-fluid px-4 py-2">
          <div
            className="container-fluid p-4"
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              boxShadow:
                "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
            }}
          >
            <div className="">
              <h1 className="heading">Order List</h1>
            </div>
            {/* main div  below heading  */}
            <div
              className="container-fluid mt-3"
              style={{
                paddingRight: "0px",
                boxShadow:
                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                borderRadius: "8px",
              }}
            >
              {orderList !== null ? (
                orderList.map((item, index) => (
                  <div className="row order-main-list">
                    {/* customer  */}
                    <div className="col-lg-4 col-md-4 order-main-list-left py-4 px-0">
                      <div className="d-flex justify-content-between align-items-center p-0 order-main-list-left-top">
                        <h4 style={{ color: "red" }}>
                          Lead ID :{" "}
                          <span style={{ color: "#6A6A6A" }}>{item.Relocation_ID}</span>
                        </h4>
                        <h4 style={{ color: "#6A6A6A", fontWeight: "bold" }}>
                          Relocation Date :{" "}
                          <span style={{ color: "#6A6A6A", fontWeight: "600" }}>
                            {item.relocation_date}
                          </span>
                        </h4>
                      </div>
                      <div
                        style={{
                          backgroundColor: "#F2F2F2",
                          padding: "16px",
                          borderRadius: "6px",
                        }}
                        className="d-flex justify-content-center align-items-center order-main-list-left-bottom"
                      >
                        <div className=" d-flex mt-1 justify-content-center align-items-center">
                          <h4
                            style={{ color: "#5B489D", fontWeight: "bolder" }}
                          >
                            {item.origin_state
                              ? item.origin_state.slice(0, 3).toUpperCase()
                              : ""}
                          </h4>
                        </div>
                        <div
                          style={{ position: "relative" }}
                          className="px-3 w-100 d-flex justify-content-start align-items-center"
                        >
                          <hr className="p-0" style={{ width: "100%" }} />
                          <img
                            src={plane}
                            className="img-fluid"
                            style={{
                              position: "absolute",
                              left: "50%",
                              width: "34px",
                            }}
                          />
                        </div>
                        <div className="d-flex mt-1 justify-content-center align-items-center">
                          <h4
                            style={{ color: "#5B489D", fontWeight: "bolder" }}
                          >
                            {item.destination_state
                              ? item.destination_state.slice(0, 3).toUpperCase()
                              : ""}
                          </h4>
                        </div>
                      </div>
                    </div>
                    {/* service type  */}
                    <div
                      style={{ paddingRight: "0px", paddingLeft: "27px" }}
                      className="col-lg-8 col-md-8 order-main-list-right"
                    >
                      <div className="row orderlist-action-div-mobile-hide">
                        <div className="col-10 px-0 py-4">
                          <div className="order-main-list-right-content px-0 py-4">
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-4"
                                >
                                  Service Type
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.service_type}
                                </span>
                              </div>
                            </div>
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-0"
                                >
                                  Pet Type
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.PetType}
                                </span>
                              </div>
                            </div>
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-4"
                                >
                                  No. of Pets
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.Number_Of_Pets}
                                </span>
                              </div>
                            </div>
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-0"
                                >
                                  Pet Name
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.pet_Name}
                                </span>
                              </div>
                            </div>
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-4"
                                >
                                  Pet Breed
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.pet_breed}
                                </span>
                              </div>
                            </div>
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-0"
                                >
                                  Pet Age
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.Pet_Age}
                                </span>
                              </div>
                            </div>
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-4"
                                >
                                  Origin
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.origin_state}, {item.origin_country}
                                </span>
                              </div>
                            </div>
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-0"
                                >
                                  Destination
                                </span>
                                <span
                                  style={{
                                    fontWeight: "600",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.destination_state},{" "}
                                  {item.destination_country}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            backgroundColor: "#DED5FA",
                            borderTopRightRadius: "7px",
                            borderBottomRightRadius: "7px",
                            paddingRight: "0px",
                          }}
                          className="col-2 d-flex justify-content-center align-items-center"
                        >
                          <div
                            style={{ position: "relative", cursor: "pointer" }}
                            className="d-flex justify-content-center align-items-center"
                            onClick={() => nextPage(item.Relocation_ID)}
                          >
                            <h4
                              style={{
                                color: "#474747",
                                fontSize: "16px",
                                padding: "0px",
                                margin: "0px",
                              }}
                            >
                              ACTION
                            </h4>
                            <ArrowRightAltIcon
                              style={{ color: "#6a6a6a" }}
                              sx={{
                                minWidth: 0,
                                mr: "auto",
                                justifyContent: "center",
                              }}
                            ></ArrowRightAltIcon>
                          </div>
                        </div>

                        <div></div>
                      </div>
                      <div className="row orderlist-action-div-mobile-show">
                        <div className="col-12">
                          <div className="order-main-list-right-content">
                            <h4
                              style={{ fontWeight: "bold", color: "#6a6a6a" }}
                            >
                              Service Type :{" "}
                              <span style={{ fontWeight: "500" }}>
                                International Export
                              </span>
                            </h4>
                            <h4
                              style={{ fontWeight: "bold", color: "#6a6a6a" }}
                            >
                              Service Type :{" "}
                              <span style={{ fontWeight: "500" }}>
                                International Export
                              </span>
                            </h4>
                            <h4
                              style={{ fontWeight: "bold", color: "#6a6a6a" }}
                            >
                              Service Type :{" "}
                              <span style={{ fontWeight: "500" }}>
                                International Export
                              </span>
                            </h4>
                            <h4
                              style={{ fontWeight: "bold", color: "#6a6a6a" }}
                            >
                              Service Type :{" "}
                              <span style={{ fontWeight: "500" }}>
                                International Export
                              </span>
                            </h4>
                            <h4
                              style={{ fontWeight: "bold", color: "#6a6a6a" }}
                            >
                              Service Type :{" "}
                              <span style={{ fontWeight: "500" }}>
                                International Export
                              </span>
                            </h4>
                            <h4
                              style={{ fontWeight: "bold", color: "#6a6a6a" }}
                            >
                              Service Type :{" "}
                              <span style={{ fontWeight: "500" }}>
                                International Export
                              </span>
                            </h4>
                          </div>
                        </div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No information available.</p>
              )}
            </div>

            {/* m
                      {/* main div  below heading  */}
          </div>
        </div>
        <div className="text-center container-fluid d-flex justify-content-center align-items-center p-4">
          <h2 style={{ color: "#CFCFCF", fontWeight: "bolder" }}>
            ThankYou ! <br />
            <span style={{ fontWeight: "400" }}>For choosing our Service.</span>
          </h2>
        </div>
      </div>

      {/* mobile view  */}
      <div
        style={{ padding: "0px", margin: "0px", backgroundColor: "#F6F3FF" }}
        className="main orderlist-mobile-view-show"
      >
        <div
          style={{ padding: "0px", margin: "0px" }}
          className="container-fluid navbar-mobile-show"
        >
          <MobileNavbar active="orderlist" />
        </div>
        <div className="" style={{ paddingTop: "88px" }}>
          <div
            className="container-fluid orderlist-hero"
            style={{
              backgroundColor: "white",
              borderRadius: "5px",
              boxShadow:
                "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
            }}
          >
            <div
              className=""
              style={{ backgroundColor: "#F6F3FF", padding: "10px" }}
            >
              <img className="img-fluid container" src={IntroMobile} />
            </div>
          </div>
        </div>
        <div className="container-fluid px-0 py-2 mt-2">
          <div
            className="container-fluid px-3 py-4"
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              boxShadow:
                "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
            }}
          >
            <div className="">
              <h1 style={{ fontSize: "20px" }} className="heading m-0">
                Order Summary
              </h1>
            </div>
            {/* main div  below heading  */}
            <div
              className="container-fluid mt-3"
              style={{
                boxShadow:
                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                borderRadius: "8px",
              }}
            >
              {orderList !== null ? (
                orderList.map((item, index) => (
                  <div className="row order-main-list">
                    {/* customer  */}
                    <div className="col-lg-5 col-md-5 order-main-list-left px-0 py-2">
                      <div className="d-flex justify-content-between align-items-center p-0 order-main-list-left-top">
                        <h4 style={{ color: "red" }}>
                          Lead ID :{" "}
                          <span style={{ color: "#6A6A6A" }}>
                            {item.Relocation_ID}{" "}
                          </span>
                        </h4>
                        <h4 style={{ color: "#6A6A6A", fontWeight: "bold" }}>
                          Relocation Date :{" "}
                          <span style={{ color: "#6A6A6A", fontWeight: "600" }}>
                            {item.relocation_date}
                          </span>
                        </h4>
                      </div>
                      <div
                        style={{
                          backgroundColor: "#F2F2F2",
                          padding: "6px",
                          borderRadius: "6px",
                        }}
                        className="d-flex justify-content-center align-items-center order-main-list-left-bottom"
                      >
                        <div className=" d-flex mt-1 justify-content-center align-items-center">
                          <h4
                            style={{
                              color: "#5B489D",
                              fontWeight: "bolder",
                              fontSize: "18px",
                            }}
                          >
                            IND
                          </h4>
                        </div>
                        <div
                          style={{ position: "relative" }}
                          className="px-3 w-100 d-flex justify-content-start align-items-center"
                        >
                          <hr className="p-0" style={{ width: "100%" }} />
                          <img
                            src={plane}
                            className="img-fluid"
                            style={{
                              position: "absolute",
                              left: "50%",
                              width: "30px",
                            }}
                          />
                        </div>
                        <div className="d-flex mt-1 justify-content-center align-items-center">
                          <h4
                            style={{
                              color: "#5B489D",
                              fontWeight: "bolder",
                              fontSize: "18px",
                            }}
                          >
                            CAN
                          </h4>
                        </div>
                      </div>
                    </div>
                    {/* service type  */}
                    <div className="col-lg-7 col-md-7 order-main-list-right px-0 py-0">
                      <div className="row orderlist-action-div-mobile-show px-0 py-3">
                        <div className="col-12 px-0">
                          <div className="order-main-list-right-content px-0">
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-0"
                                >
                                  Service Type
                                </span>
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.service_type}
                                </span>
                              </div>
                            </div>
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-0"
                                >
                                  Pet Type
                                </span>
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.PetType}
                                </span>
                              </div>
                            </div>
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-0"
                                >
                                  No. of Pets
                                </span>
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.Number_Of_Pets}
                                </span>
                              </div>
                            </div>
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-0"
                                >
                                  Pet Name & Breed
                                </span>
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.pet_Name} ({item.pet_breed})
                                </span>
                              </div>
                            </div>
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-0"
                                >
                                  Origin
                                </span>
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.origin_state}, {item.origin_country}
                                </span>
                              </div>
                            </div>
                            <div class="container-fluid p-0 text-start">
                              <div class="row">
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-5 py-0 px-0"
                                >
                                  Destination
                                </span>
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    color: "#6a6a6a",
                                    fontSize: "14px",
                                  }}
                                  class="col-7 p-0"
                                >
                                  : {item.destination_state},{" "}
                                  {item.destination_country}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No information available.</p>
              )}
            </div>

            {/* main div  below heading  */}
            <div
              className="container-fluid mt-3"
              style={{
                boxShadow:
                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                borderRadius: "8px",
              }}
            >
              
            </div>
            {/* main div  below heading  */}
          </div>
        </div>
        <div className="text-center container-fluid d-flex justify-content-center align-items-end p-4">
          <h2
            style={{ color: "#CFCFCF", fontWeight: "bolder", fontSize: "17px" }}
          >
            ThankYou ! <br />
            <span style={{ fontWeight: "400" }}>For choosing our Service.</span>
          </h2>
        </div>
      </div>
    </>
  );
}

export default Orderlist;
